import React from 'react';
import { NavLink } from 'react-router-dom';
import Banner from '../components/Banner';
import Navigation from '../components/navigation2';
import Footer from '../components/Footer';
import '../styles/pages/tarifs.css';

const Tarifs = () => {
    return (
        <div>
            <Banner />
            <div className='pagetarifs'>
                <Navigation />
                <h1 className='mentions_titre'>Découvrez nos tarifs adaptés à vos besoins.</h1>
                <h2 className='titre3'>Des solutions sur-mesure pour chaque projet</h2>
                <h2 className='titre3'>Les tarifs ci-dessous seront adaptés à votre projet</h2>
                <h2 className='titre3'>N'hésitez pas à me contacter pour un devis personnalisé.</h2>
                <div className='prestations'>
                    <div className='prestations_bloc bloc1'>
                        <h3 className='prestations_bloc_titre'>SITE VITRINE STANDARD</h3>
                        <p className='prestations_bloc_texte'>Pour un site simple de 3 à 5 pages, idéal pour présenter votre activité en ligne.</p>
                        <p className='prestations_bloc_texte coche'>Design personnalisé</p>
                        <p className='prestations_bloc_texte coche'>Ajout d'un formulaire de contact</p>
                        <p className='prestations_bloc_texte coche'>Site responsaive (Fonctionne sur mobile)</p>
                        <p className='prestations_bloc_texte prix'>A partir de 899 €</p>
                    </div>
                    <div className='prestations_bloc bloc2'>
                        <h3 className='prestations_bloc_titre'>SITE VITRINE COMPLEXE</h3>
                        <p className='prestations_bloc_texte'>Pour un site de 6 à 10 pages avec des fonctionnalités avancées.</p>
                        <p className='prestations_bloc_texte coche'>Design personnalisé</p>
                        <p className='prestations_bloc_texte coche'>Ajout d'un formulaire de contact</p>
                        <p className='prestations_bloc_texte coche'>Contenu optimisé pour le SEO (Meilleur référencement de votre site web)</p>
                        <p className='prestations_bloc_texte coche'>Intégration de médias interactifs</p>
                        <p className='prestations_bloc_texte coche'>Plusieurs élements animés</p>
                        <p className='prestations_bloc_texte coche'>Site responsaive (Fonctionne sur mobile)</p>
                        <p className='prestations_bloc_texte prix'>A partir de 1299 €</p>
                    </div>
                </div>
                <div className='prestations'>
                    <div className='prestations_bloc bloc2'>
                        <h3 className='prestations_bloc_titre'>SITE E-COMMERCE</h3>
                        <p className='prestations_bloc_texte'>Pour un site de vente en ligne complet</p>
                        <p className='prestations_bloc_texte coche'>Design personnalisé</p>
                        <p className='prestations_bloc_texte coche'>Ajout d'un formulaire de contact</p>
                        <p className='prestations_bloc_texte coche'>Contenu optimisé pour le SEO (Meilleur référencement de votre site web)</p>
                        <p className='prestations_bloc_texte coche'>Intégration de médias interactifs</p>
                        <p className='prestations_bloc_texte coche'>Plusieurs élements animés</p>
                        <p className='prestations_bloc_texte coche'>Site responsaive (Fonctionne sur mobile)</p>
                        <p className='prestations_bloc_texte coche'>Intégration de passerelles de paiement sécurisées</p>
                        <p className='prestations_bloc_texte coche'>Gestion des commandes</p>
                        <p className='prestations_bloc_texte coche'>Gestion des stocks</p>
                        <p className='prestations_bloc_texte coche'>Support client intégré</p>
                        <p className='prestations_bloc_texte prix'>A partir de 2299 €</p>
                    </div>
                    <div className='prestations_bloc bloc1'>
                        <h3 className='prestations_bloc_titre'>Amélioration SEO</h3>
                        <p className='prestations_bloc_texte coche'>Pour optimiser la visibilité de votre site sur les moteurs de recherche.</p>
                        <p className='prestations_bloc_texte prix'>tarification horaire : 40€ / H</p>
                    </div>
                </div>
                <div className='prestations'>
                    <div className='prestations_bloc bloc1'>
                        <h3 className='prestations_bloc_titre'>FORFAIT MAINTENANCE de votre site Web</h3>
                        <p className='prestations_bloc_texte prix'>200 € / AN</p>
                        <p className='prestations_bloc_texte'>Ce forfait inclut des mises à jour régulières et le support technique.</p>
                    </div>
                </div>
            </div>
            <div className='tarif_compl_bloc'>
                <h2 className='mention_titre'>Vous souhaitez avoir des informations ou obtenir un devis gratuit ?</h2>
                <h2 className='mentions_titre'>N'hésitez pas à me contacter pour une étude précise de votre projet</h2>
                <p className='blocformulaire'>
                    <NavLink to="/contact">
                        <p className="ouvrir-formulaire">Ouvrir le formulaire de contact</p>
                    </NavLink>
                </p>
            </div>
            <Footer />
        </div>
    );
};

export default Tarifs;